<div class="alert alert-danger custom-alert" *ngIf="messageService.message" role="alert">
    <span>{{ messageService.message.text }}</span>
    <a *ngIf="messageService.message.action" [href]="messageService.message.action.href">
        {{ messageService.message.action.label }}
    </a>&nbsp;
    <button class="basic-button-base button-dark" (click)="messageService.hideMessage()">
        Dismiss
    </button>
</div>


<div class="alert alert-info custom-alert" *ngIf="messageService.infoMessage" role="alert">
    <span>{{ messageService.infoMessage.text }}</span>
    <a *ngIf="messageService.infoMessage.action" [href]="messageService.infoMessage.action.href">
        {{ messageService.infoMessage.action.label }}
    </a>&nbsp;
    <button class="basic-button-base button-dark" (click)="messageService.hideInfo()">
        Dismiss
    </button>
</div>
